<template>
  <modal id="form-registro-td" :titulo="titulo" :loading="!form">
    <form @submit.prevent="" v-if="form" autocomplete="off">
      <card>
        <card-content class="row gutters-xs">
          <v-input v-if="form.id && form.status !== 'PENDENTE'" :error="validation.status" v-model="form.status"
                   :options="options.statusEdicao" type="select" class="col-5" label="Situação" />
        </card-content>
      </card>
    </form>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Cancelar</button>
      <v-button :run="salvar" class="btn-outline-primary">Salvar</v-button>
    </template>
  </modal>
</template>

<script>
import {defineComponent} from "vue";
import Modal from "@/components/Modal.vue";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import FrontBusiness from "@/business/FrontBusiness";
import utils from "@/commons/Utils";
import RegistroNotasBusiness from "@/business/indicadores/RegistroNotasBusiness";

export default defineComponent({
  name: "FormRegistroNotas",
  components: { Card, CardContent, Modal },

  props: {
    id: String,
    livro: String,
    clone: {type: Object, default: () => ({})}
  },

  modal: {
    escapable: false
  },

  data() {
    return {
      form: null,
      validation: {},
      titulo: '',
      options: {
        statusEdicao: [],
      }
    };
  },

  async mounted() {

    let registroNotas = {};

    if (this.id) {
      registroNotas = await RegistroNotasBusiness.getById(this.id);
      this.titulo = `Editar ${this.nomearLivro(registroNotas)}`;
    } else {
      this.titulo = 'Adicionar ' + this.nomeLivro;
      registroNotas = {...this.clone};
    }

    const livroParaStatus = registroNotas.livro || this.livro;
    this.options.statusEdicao = await RegistroNotasBusiness.getStatusPorDominio(livroParaStatus);

    let form = {
      ...registroNotas
    };

    this.$set(this, 'form', form);
  },

  computed: {
    nomeLivro() {
      return FrontBusiness.nomearFicha({livro: this.form?.livro || this.livro, status: ''}, false);
    },
  },

  methods: {
    nomearLivro: FrontBusiness.nomearFicha,

    close() {
      FrontBusiness.closeModal();
    },

    showError(e) {
      FrontBusiness.fullErrorHandler(this, e, '#form-registro-notas');
    },

    async salvar() {
      let dto = utils.clone(this.form);

      if (!this.id) {
        FrontBusiness.closeModal(dto);
        return;
      }

      let registroNotas = await RegistroNotasBusiness.save(this.id, dto).catch(this.showError);
      if (registroNotas) {
        FrontBusiness.closeModal(registroNotas);
      }
    },
  }
});
</script>
